/* Solo actualiza el reloj y el mensaje de campaÃ±a. No modifica precios ni carrito. */
(() => {
  const mounted = new WeakMap();
  function mount(scope = document) {
    scope.querySelectorAll('[data-vbf-clock]').forEach(clock => {
      if (mounted.has(clock)) return;
      const root = clock.closest('[data-vbf-phase]');
      const start = Date.parse(clock.dataset.start);
      const end = Date.parse(clock.dataset.end);
      if (!root || !Number.isFinite(start) || !Number.isFinite(end) || end <= start) return;
      const automatic = clock.dataset.mode === 'auto';
      const fields = ['days', 'hours', 'minutes', 'seconds'].map(key => clock.querySelector(`[data-vbf-${key}]`));
      const label = clock.querySelector('[data-vbf-clock-label]');
      const tick = () => {
        if (!clock.isConnected) { clearInterval(mounted.get(clock)); mounted.delete(clock); return; }
        const now = Date.now();
        const phase = automatic ? (now < start ? 'before' : now < end ? 'live' : 'ended') : root.dataset.vbfPhase;
        if (automatic) root.dataset.vbfPhase = phase;
        const target = phase === 'before' ? start : end;
        const seconds = Math.max(0, Math.floor((target - now) / 1000));
        clock.hidden = phase === 'ended' || seconds === 0;
        if (clock.hidden) return;
        label.textContent = phase === 'before' ? 'El Buen Fin empieza en' : 'La promociÃ³n por cantidad termina en';
        const values = [Math.floor(seconds / 86400), Math.floor(seconds / 3600) % 24, Math.floor(seconds / 60) % 60, seconds % 60];
        fields.forEach((el, i) => { el.textContent = String(values[i]).padStart(2, '0'); });
      };
      mounted.set(clock, setInterval(tick, 1000));
      tick();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(), {once: true});
  else mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();